export const ROW_BUFFER = 5;

export function calculateVisibleRows(scrollTop, containerHeight, cellHeight, totalItems, items) {
    if (!containerHeight || !cellHeight || totalItems === 0) {
        return [];
    }

    // Calculate visible range with buffer
    const visibleCount = Math.ceil(containerHeight / cellHeight) + ROW_BUFFER * 2;
    const firstIndex = Math.max(0, Math.floor(scrollTop / cellHeight) - ROW_BUFFER);
    const lastIndex = Math.min(totalItems - 1, firstIndex + visibleCount - 1);

    // Build visible rows
    const rows = [];
    for (let i = firstIndex; i <= lastIndex; i++) {
        rows.push({
            index: i,
            item: items.get(i) || null,
            isPlaceholder: !items.has(i)
        });
    }

    return rows;
}

export default {
    ROW_BUFFER,
    calculateVisibleRows
};
